var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "picker-column", class: _vm.className }, [
    _c(
      "ul",
      {
        ref: "wrapper",
        staticClass: "wrapper",
        style: _vm.wrapperStyle,
        on: { transitionend: _vm.onTransitionEnd },
      },
      _vm._l(_vm.options, function (option, index) {
        return _c(
          "li",
          {
            key: index,
            staticClass: "item",
            class: {
              disabled: option && option.disabled,
              selected: index === _vm.currentIndex,
            },
            style: _vm.itemStyle,
            on: {
              click: function ($event) {
                return _vm.onClickItem(index)
              },
            },
          },
          [
            _vm.allowHtml
              ? _c("div", {
                  staticClass: "ellipsis",
                  domProps: { innerHTML: _vm._s(_vm.getOptionText(option)) },
                })
              : _c("div", { staticClass: "ellipsis" }, [
                  _vm._v(_vm._s(_vm.getOptionText(option))),
                ]),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }